import { gql } from '@apollo/client';

export const TokenAuth = gql`
    mutation tokenAuth($password: String!, $email: String!) {
        tokenAuth(password: $password, email: $email) {
            success
            errors
            user {
                id
                email
                isVerified
                isAgentCreated
                isFinishedStepper
                isSubscribed
            }
            token {
                token
            }

            refreshToken {
                token
                isExpired
            }
        }
    }
`;
